import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import TrustBadgesSection from './components/TrustBadgesSection';
import CategoryGrid from './components/CategoryGrid';
import WhyChooseUs from './components/WhyChooseUs';
import ComparisonTable from './components/ComparisonTable';
import SafetySection from './components/SafetySection';
import FAQSection from './components/FAQSection';
import ArticleGrid from './components/ArticleGrid';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import StructuredData from './components/StructuredData';

export default function Home() {
  return (
    <>
      <StructuredData />
      <Navbar />
      <main>
        <HeroSection />
        <TrustBadgesSection />
        <CategoryGrid />
        <WhyChooseUs />
        <ComparisonTable />
        <SafetySection />
        <FAQSection />
        <ArticleGrid />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}